import { useState, useEffect } from "react";

import { INTERVAL_ONE_SECOND } from "../../../constant/constants";
import Lottie from "lottie-react";
import animation from "../../../assets/animation/MZKc7dDskN.json";

const DateAndTime: React.FC = () => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();

      const day = now.getDate().toString().padStart(2, "0");
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const fullYear = now.getFullYear();

      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");

      setDate(`${day}.${month}.${fullYear}.`);
      setTime(`${hours}:${minutes}:${seconds}`);
    }, INTERVAL_ONE_SECOND);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {date.length > 0 && time.length > 0 ? (
        <span className="date_time">
          {`${date}`}
          <strong> | </strong>
          {`${time}`}
        </span>
      ) : (
        <span className="date_time spinner">
          <Lottie
            animationData={animation}
            loop={true}
            autoPlay={true}
            style={{
              width: "17px",
              height: "17px",
              transformOrigin: "center",
              transform: "scale(3)",
              overflow: "hidden",
            }}
          ></Lottie>
        </span>
      )}
    </div>
  );
};

export default DateAndTime;
